import { IconButton as MuiIconButton, type IconButtonProps as MuiIconButtonProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * FSE IconButton — thin wrapper over MUI IconButton for compact icon-only
 * affordances (e.g. a dialog close "X", row actions). Always pass an
 * `aria-label` for accessibility. Exposed through @fse/ui so consumers never
 * import @mui/material directly (swap-promise).
 */
export type IconButtonProps = MuiIconButtonProps;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  props,
  ref,
) {
  return <MuiIconButton ref={ref} {...props} />;
});
